/**
 * File thelfire.js
 */

'use strict';

;( function() {

	const form = document.querySelectorAll( '#thelfire-configurator' )[0];

	if ( ! form ) {
		return false;
	}

	const container = form.parentNode;
	const origin    = window.location.origin;

	const states = {
		de: 'Delaware',
		dc: 'DC',
		md: 'Maryland',
		nj: 'New Jersey',
		nc: 'North Carolina',
		pa: 'Pennsylvania',
		va: 'Virginia',
		wv: 'West Virginia',
	};

	setMinHeight( container );

	listenForFade( container );

	form.addEventListener( 'submit', function( event ) {

		event.preventDefault();

		const licenseType = this.elements['license-type'].value;
		const state       = this.elements['state'].value;

		if ( ( '' === licenseType ) || ( '' === state ) ) {
			alert( 'Please select a license type and a state.' );
			return false;
		}

		let   query       = origin + '/wp-json/wp/v2/pages';
		let   type        = '';

		if ( 'reciprocal' === licenseType ) {
			fadeOut( this );
			query += '?parent=88&slug=' + state;
			type   = 'Multiple Licensing';
		} else {

			if ( 'md' === state ) {
				window.location.href = origin + '/information-for-maryland-students';
				return false;
			} else {
				query += '/109';
				type   = 'Pre-Licensing';
			}
		}

		// Retrieve and display data.
		const request = new XMLHttpRequest();
		request.open( 'GET', query, true );
		request.onload = function() {

			if ( 200 <= this.status && 400 > this.status ) {

				let data    = JSON.parse( this.response );
				let title   = '';
				let content = '';

				if ( Array === data.constructor ) {
					data = data[0];
				}

				if ( 'Multiple Licensing' === type ) {
					title = `<h2>${type} in ${states[state]}</h2>`;
				} else {
					title = `<h2>${data.title.rendered} in ${states[state]}</h2>`;
				}

				content = decodeEntities( data.content.rendered );

				container.innerHTML = title + content;
				container.parentNode.classList.remove( 'fade' );
			}
		};
		request.send();
	});

	function listenForFade( container ) {

		const childElements = Array.from( container.querySelectorAll( '*' ) );

		childElements.forEach( el => {

			el.addEventListener( 'transitionend', function() {
				this.remove();
			});
		});
	};

	function fadeOut( element ) {
		element.parentNode.parentNode.classList.add( 'fade' );
	};

	function decodeEntities( html ) {

		// not a string, or no entities to decode
		if ( 'string' !== typeof html || -1 === html.indexOf( '&' ) ) return html;

		let _decodeTextArea;

		if ( document.implementation && document.implementation.createHTMLDocument ) {

			_decodeTextArea = document.implementation.createHTMLDocument( '' ).createElement( 'textarea' );

		} else {

			_decodeTextArea = document.createElement( 'textarea' );
		}

		_decodeTextArea.innerHTML = html;
		const decoded = _decodeTextArea.textContent;
		_decodeTextArea.innerHTML = '';
		return decoded;
	};

	function setMinHeight( container ) {
		const height = container.offsetHeight;

		container.setAttribute( 'style', 'min-height:' + height + 'px' );
	};
}() );
